import React from 'react';

import useStyles from './Style';

const Link = (props) => {
    const classes = useStyles();

    return (
        <a className={classes.link} href={`#anchor-${props.anchor}`} >
            {props.children}
        </a>
    )
}

const NavbarRegulamento = ({ edicao }) => {
    const classes = useStyles();

    return (
        <div className={classes.nav}>
            <Link anchor="01">1. DISPOSIÇÕES PRELIMINARES</Link>
            <Link anchor="02">2. DOS PARTICIPANTES</Link>
            <Link anchor="03">3. DA INSCRIÇÃO</Link>
            <Link anchor="04">4. CRONOGRAMA</Link>
            <Link anchor="05">5. ESTRUTURA DA PROVA</Link>
            <Link anchor="06">6. APLICAÇÃO DA PROVA</Link>
            <Link anchor="07">7. PREMIAÇÃO</Link>
            <Link anchor="08">8. OBRIGAÇÕES DO PROFESSOR</Link>
            <Link anchor="09">9. OBRIGAÇÕES DO IMPA</Link>
            <Link anchor="10">10. DISPOSIÇÕES FINAIS</Link>

            <Link anchor="a1">ANEXO I – Calendário Oficial da {edicao}ª Olimpíada de Professores da OBMEP Mirim</Link>
            <Link anchor="a2">ANEXO II – Normas para pagamento da taxa de inscrição para professores de escolas privadas</Link>
            <Link anchor="a3">ANEXO III – Premiação</Link>
        </div>
    )
}

export default NavbarRegulamento;